export enum IdDocumentType {
  DriverLicense = 'license',
  Passport = 'passport',
  NoOption = '',
}
